/* eslint-disable */

import Vue from "vue";
import Vuex from "vuex";

import modules from './modules';
Vue.use(Vuex);

const debug = process.env.NODE_ENV !== 'production';
const store = new Vuex.Store({
	strict: debug, // SET to only true in debug/dev
	modules: modules
});

export default store;
for (const moduleName of Object.keys(modules)) {
	if (modules[moduleName].actions && modules[moduleName].actions.initStore) {
		store.dispatch(`${moduleName}/initStore`);
	}
}